import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import h, { useImperativeHandle as z, useMemo as L, useEffect as M } from "react";
import N from "react-dom";
import { l as A } from "./lodash-5ofSKtz3.mjs";
import { a as K } from "./hooks-DlFaCTNC.mjs";
import { f as o } from "./index-LyFokDcn.mjs";
import { m as b } from "./tss-DN0acMKN.mjs";
import { _ as Q } from "./composeRefs-YONvD-rx.mjs";
import { F } from "./flex-Cc3osQLf.mjs";
import { H as Z } from "./headline-DF2GOgMa.mjs";
import { I as j } from "./icon-button-BxDvkq_l.mjs";
import { I as q } from "./X16x16-WqWrwByX.mjs";
const G = b()((e, t) => {
  const { borderRadiuses: i, constructs: r, mixins: l, palette: a, spacing: u } = e, { initialHeight: m, initialOffsetRight: p, initialOffsetTop: x, open: g, width: s, zIndex: R } = t;
  return {
    root: {
      backgroundColor: o.ifFeature("encore", r.surface.neutral.inverted, a.background.default),
      border: "none",
      borderRadius: o.ifFeature("encore", i[400], "inherit"),
      boxShadow: o.ifFeature("encore", l.boxShadow("700", r.surface.neutral.xxStrong), "0px 8px 16px 0px #00000026"),
      display: g ? "flex" : "none",
      flexDirection: "column",
      height: m,
      marginRight: p,
      padding: o.ifFeature("encore", u(0.5), 0),
      position: "fixed",
      textAlign: "left",
      top: x,
      width: s,
      zIndex: R
    }
  };
}), W = b()(({ borderRadiuses: e }) => ({
  footer: {
    borderBottomLeftRadius: o.ifFeature("encore", e[300], void 0),
    borderBottomRightRadius: o.ifFeature("encore", e[300], void 0),
    overflow: "hidden"
  }
})), J = ({ children: e }) => {
  const { classes: t } = W();
  return /* @__PURE__ */ n.jsx("div", { className: t.footer, children: e });
}, P = b()(({ borderRadiuses: e, constructs: t, palette: i, spacing: r }) => ({
  header: {
    backgroundColor: o.ifFeature("encore", t.surface.neutral.xxWeak, i.gray[100]),
    borderTopLeftRadius: o.ifFeature("encore", e[300], void 0),
    borderTopRightRadius: o.ifFeature("encore", e[300], void 0),
    height: "100%",
    padding: r(1.5, 2)
  }
})), U = ({ apiRef: e, onClose: t, icon: i, title: r, biId: l }) => {
  const { classes: a } = P();
  return z(
    e,
    () => ({
      onClose: () => t()
    }),
    [t]
  ), /* @__PURE__ */ n.jsx(F, { flexDirection: "column", flexGrow: 0, children: /* @__PURE__ */ n.jsx("div", { className: a.header, children: /* @__PURE__ */ n.jsxs(F, { alignItems: "center", gap: 1, justifyContent: "space-between", children: [
    /* @__PURE__ */ n.jsx(Z, { color: o.ifFeature("encore", "primary", "neutral-strong"), icon: i, size: "small", children: r }),
    o.ifFeature(
      "encore",
      /* @__PURE__ */ n.jsx(
        j,
        {
          "aria-label": window.jQuery ? $.__("close modal") : "close modal",
          biId: l,
          icon: "xmark-solid",
          onClick: t,
          size: "extra-small",
          type: "button",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ n.jsx(
        j,
        {
          "aria-label": window.jQuery ? $.__("close modal") : "close modal",
          biId: l,
          icon: /* @__PURE__ */ n.jsx(q, { "aria-hidden": "true" }),
          noBoundingBox: !0,
          onClick: t,
          type: "button"
        }
      )
    )
  ] }) }) });
}, E = ({
  children: e,
  container: t,
  footer: i,
  header: r,
  height: l,
  id: a,
  initialHeight: u,
  initialOffsetRight: m,
  initialOffsetTop: p,
  offsetRight: x,
  offsetTop: g,
  open: s,
  scrollContainerRef: R,
  width: I = "300px"
}) => {
  const c = L(() => typeof a == "string" ? a : A.uniqueId("fabric-dialog-"), [a]), v = h.useRef(null), w = t ? document.getElementById(t) : document.body, O = K(s), _ = u || l || "600px", k = m || x || "64px", C = p || g || "24px", { classes: H } = G({
    initialHeight: _,
    initialOffsetRight: k,
    initialOffsetTop: C,
    open: s,
    width: I,
    zIndex: O
  }), d = h.useRef(null);
  M(() => {
    v.current && s && window.dispatchEvent(
      new CustomEvent("dialogOpened", {
        bubbles: !0,
        detail: {
          id: c
        }
      })
    );
    const f = (T) => {
      var y;
      s && c !== T.detail.id && ((y = d.current) == null || y.onClose());
    };
    return window.addEventListener("dialogOpened", f), () => {
      window.removeEventListener("dialogOpened", f);
    };
  }, [c, s]);
  const B = (f) => {
    f.key === "Escape" && d.current && d.current.onClose();
  }, D = r.props, S = Q(D.apiRef, d);
  return w ? N.createPortal(
    /* @__PURE__ */ n.jsxs("dialog", { className: H.root, "data-fabric-component": "Dialog", id: c, onKeyDown: B, ref: v, children: [
      h.cloneElement(r, {
        // Overrides the apiRef with the combined ref
        apiRef: S
      }),
      e,
      i
    ] }),
    w
  ) : null;
};
E.Header = U;
E.Footer = J;
export {
  E as D
};
//# sourceMappingURL=dialog-70hfvYIy.mjs.map
